import { MenuItem, TextField } from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";

import useStyles from "./useStyles";

/**
 * 選択テキストフィールドコンポーネント.
 *
 * @param {string} label ラベル
 * @param {string} value 値
 * @param {function} onChange 値が変化したときの処理
 * @param {function} onClick 値をクリックしたときの処理
 * @param {object} items 選択アイテム
 * @return {object} コンポーネント
 */
function SelectOfficeField(props) {
  // 引数
  const {
    // ラベル
    label,
    // スタイル
    variant,
    // 値
    value,
    // 値が変化したときの処理
    onChange,
    // 値をクリックしたときの処理
    onClick,
    // 選択アイテム
    items,
  } = props;

  // スタイル
  const styles = useStyles();

  return (
    <TextField
      className={styles.textFiled}
      select
      label={label}
      variant={variant}
      value={value}
      onChange={onChange}
      onClick={onClick}
    >
      {items.map((item) => (
        <MenuItem key={item.serialNumber} value={item.serialNumber}>
          {`${item.serialNumber} : ${item.label}`}
        </MenuItem>
      ))}
    </TextField>
  );
}

SelectOfficeField.propTypes = {
  label: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["standard", "filled", "outlined"]),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
};

SelectOfficeField.defaultProps = {
  variant: "standard",
  onChange: () => ({}),
  onClick: () => ({}),
};

export default SelectOfficeField;
